import styled from 'styled-components';

const Instructions = styled.p`
   color: ${({ theme, color = theme.primaryBlueLight }: { theme: any; color?: string }) => color};
   font-weight: bold;
   line-height: 1.4;
   text-align: center;
   margin-bottom: 1em;
   display: block;
   padding-bottom: 2em;
`;

export default Instructions;
